import React from 'react';
import { Box } from '@apia/theme';
import {
  TResponsiveTableCellRenderer,
  TResponsiveTableCellRendererProps,
} from '../types';

const HTMLCellRenderer: TResponsiveTableCellRenderer<{ html: string }> =
  React.forwardRef<
    HTMLTableCellElement,
    TResponsiveTableCellRendererProps<{ html: string }>
  >(
    (
      {
        cell: { children, Renderer, rendererProps, AccordionRenderer, ...cell },
        className,
      },
      currentRef,
    ) => (
      <Box
        id="2"
        ref={currentRef as React.RefObject<HTMLTableCellElement>}
        {...cell}
        {...(rendererProps?.html
          ? {
              dangerouslySetInnerHTML: {
                __html: rendererProps.html.replaceAll(
                  /<TOK(\d+)/g,
                  '&lt;TOK$1',
                ),
              },
            }
          : { children })}
        className={className}
      />
    ),
  );

export default HTMLCellRenderer;
